import zip from 'lodash.zip';
import { Endpoint } from './endpoint';
import { entityFromSchema } from './entityFromSchema';
import { Resource } from './resource';
import { toSlugs } from './toSlugs';
import { visitOperations } from './visitOperations';
export class Service {
    constructor(openAPI) {
        var _a, _b, _c;
        this.openAPI = openAPI;
        this.otherEndpoints = [];
        const tags = (_a = this.openAPI.tags) !== null && _a !== void 0 ? _a : [];
        const resourceSlugs = toSlugs(tags.map((tag) => tag.name));
        this.resources = zip(tags, resourceSlugs).map(([tag, resourceSlug]) => new Resource(tag, resourceSlug));
        for (const resource of this.resources) {
            visitOperations(openAPI, (path, pathItem, method, operation) => {
                var _a;
                if (((_a = operation.tags) !== null && _a !== void 0 ? _a : []).includes(resource.tag.name)) {
                    const endpoint = new Endpoint(path, pathItem, method, operation, this, resource);
                    resource.endpoints.push(endpoint);
                }
            });
        }
        const allTagNames = tags.map((tag) => tag.name);
        visitOperations(openAPI, (path, pathItem, method, operation) => {
            var _a;
            const operationTags = (_a = operation.tags) !== null && _a !== void 0 ? _a : [];
            if (operationTags.length === 0 || !operationTags.some((tagName) => allTagNames.includes(tagName))) {
                const endpoint = new Endpoint(path, pathItem, method, operation, this, null);
                this.otherEndpoints.push(endpoint);
            }
        });
        const entities = [];
        for (const [schemaName, schema] of Object.entries((_c = ((_b = this.openAPI.components) !== null && _b !== void 0 ? _b : {}).schemas) !== null && _c !== void 0 ? _c : {})) {
            const entity = entityFromSchema(schema);
            entities.push(entity);
        }
        this.entities = entities;
    }
    get title() {
        return this.openAPI.info.title;
    }
    get summary() {
        var _a;
        if ('summary' in this.openAPI.info) {
            return (_a = this.openAPI.info.summary) !== null && _a !== void 0 ? _a : this.openAPI.info.title;
        }
        return this.openAPI.info.title;
    }
    get description() {
        return this.openAPI.info.description;
    }
    get slug() {
        return '';
    }
    get allEndpoints() {
        return [...this.resources.flatMap((resource) => resource.endpoints), ...this.otherEndpoints];
    }
}
